import React, { useState } from 'react';
import { Mui, MuiIcons } from '@osu/react-ui';
import { getAvailableScenarios, getScenarioLabel } from '../../../services/mock/applicationData';

/**
 * Enhanced DashboardDebugPanel Component for V2
 * Development tools for testing different scenarios and viewing data
 */
function DashboardDebugPanel({ 
  applicationData, 
  currentScenario, 
  onScenarioChange,
  timelineSteps = [],
  stepNavigation = null
}) {
  const availableScenarios = getAvailableScenarios();
  const [expanded, setExpanded] = useState(false);

  return (
    <Mui.Accordion 
      expanded={expanded} 
      onChange={(e, isExpanded) => setExpanded(isExpanded)}
      sx={{ mt: 4 }}
    >
      <Mui.AccordionSummary expandIcon={<MuiIcons.ExpandMore />}>
        <Mui.Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <MuiIcons.BugReport color="warning" />
          <Mui.Typography variant="h6">Debug Panel V2</Mui.Typography>
          <Mui.Chip label="Development" color="warning" size="small" />
        </Mui.Box>
      </Mui.AccordionSummary>
      
      <Mui.AccordionDetails>
        {/* Scenario Selector */}
        <Mui.Box sx={{ mb: 3 }}>
          <Mui.FormControl fullWidth size="small">
            <Mui.InputLabel>Test Scenario</Mui.InputLabel>
            <Mui.Select
              value={currentScenario || ''}
              label="Test Scenario"
              onChange={(e) => onScenarioChange(e.target.value)}
            >
              {availableScenarios.map((scenario) => (
                <Mui.MenuItem key={scenario} value={scenario}>
                  {getScenarioLabel(scenario)}
                </Mui.MenuItem>
              ))}
            </Mui.Select>
          </Mui.FormControl>
        </Mui.Box>

        {/* Data Summary */}
        <Mui.Box sx={{ mb: 2 }}>
          <Mui.Typography variant="subtitle2" gutterBottom>
            Current Scenario: {currentScenario ? getScenarioLabel(currentScenario) : 'Real Data'}
          </Mui.Typography>
          {/* <Mui.Typography variant="subtitle2" gutterBottom>
            Application Type: {applicationType}
          </Mui.Typography> */}
          <Mui.Typography variant="subtitle2" gutterBottom>
            Timeline Steps: {timelineSteps.length}
          </Mui.Typography>
          
          {/* Step Navigation Info */}
          {stepNavigation && (
            <>
              <Mui.Typography variant="subtitle2" gutterBottom>
                Active Step: {stepNavigation.activeStepIndex + 1} of {stepNavigation.getTotalSteps()} 
                ({stepNavigation.activeStep?.title || 'None'})
              </Mui.Typography>

              <Mui.Typography variant="subtitle2" gutterBottom>
                Visible Steps: {stepNavigation.visibleSteps.length}
              </Mui.Typography>
              <Mui.Typography variant="subtitle2" gutterBottom>
                Next Action: {stepNavigation.nextAction?.label || 'None'}
              </Mui.Typography>
              <Mui.Typography variant="subtitle2" gutterBottom>
                Application Complete: {stepNavigation.isComplete ? 'Yes' : 'No'}
              </Mui.Typography>
            </>
          )}
        </Mui.Box>

        {/* Raw Data Display */}
        <Mui.Accordion>
          <Mui.AccordionSummary expandIcon={<MuiIcons.ExpandMore />}>
            <Mui.Typography variant="subtitle1">Raw Application Data</Mui.Typography>
          </Mui.AccordionSummary>
          <Mui.AccordionDetails>
            <Mui.Typography variant="body2" component="pre" sx={{ 
              backgroundColor: 'grey.100', 
              p: 2, 
              borderRadius: 1, 
              overflow: 'auto',
              fontSize: '0.75rem',
              maxHeight: '300px'
            }}>
              {JSON.stringify(applicationData, null, 2)}
            </Mui.Typography>
          </Mui.AccordionDetails>
        </Mui.Accordion>

        {/* Timeline Steps Data */}
        <Mui.Accordion sx={{ mt: 1 }}>
          <Mui.AccordionSummary expandIcon={<MuiIcons.ExpandMore />}>
            <Mui.Typography variant="subtitle1">Timeline Steps Data</Mui.Typography>
          </Mui.AccordionSummary>
          <Mui.AccordionDetails>
            <Mui.Typography variant="body2" component="pre" sx={{ 
              backgroundColor: 'grey.100', 
              p: 2, 
              borderRadius: 1, 
              overflow: 'auto',
              fontSize: '0.75rem',
              maxHeight: '300px'
            }}>
              {JSON.stringify(timelineSteps, null, 2)}
            </Mui.Typography>
          </Mui.AccordionDetails>
        </Mui.Accordion>
      </Mui.AccordionDetails>
    </Mui.Accordion>
  );
}

export default DashboardDebugPanel;